import * as React from 'react'
import {
  CommandRoot,
  CommandInput as CmdInput,
  CommandList as CmdList,
  CommandEmpty as CmdEmpty,
  CommandGroup as CmdGroup,
  CommandItem as CmdItem,
} from 'cmdk'
import { cn } from '@/lib/utils'

export const Command = React.forwardRef<
  React.ElementRef<typeof CommandRoot>,
  React.ComponentPropsWithoutRef<typeof CommandRoot>
>(({ className, ...props }, ref) => (
  <CommandRoot
    ref={ref}
    className={cn(
      'flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground',
      className,
    )}
    {...props}
  />
))
Command.displayName = 'Command'

export const CommandInput = React.forwardRef<
  React.ElementRef<typeof CmdInput>,
  React.ComponentPropsWithoutRef<typeof CmdInput>
>(({ className, ...props }, ref) => (
  <div className="flex items-center border-b px-3" cmdk-input-wrapper="">
    <CmdInput
      ref={ref}
      className={cn(
        'flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground',
        className,
      )}
      {...props}
    />
  </div>
))
CommandInput.displayName = 'CommandInput'

export const CommandList = React.forwardRef<
  React.ElementRef<typeof CmdList>,
  React.ComponentPropsWithoutRef<typeof CmdList>
>(({ className, ...props }, ref) => (
  <CmdList
    ref={ref}
    className={cn('max-h-[300px] overflow-y-auto overflow-x-hidden', className)}
    {...props}
  />
))
CommandList.displayName = 'CommandList'

export const CommandEmpty = React.forwardRef<
  React.ElementRef<typeof CmdEmpty>,
  React.ComponentPropsWithoutRef<typeof CmdEmpty>
>(({ className, ...props }, ref) => (
  <CmdEmpty
    ref={ref}
    className={cn('py-6 text-center text-sm', className)}
    {...props}
  />
))
CommandEmpty.displayName = 'CommandEmpty'

export const CommandGroup = React.forwardRef<
  React.ElementRef<typeof CmdGroup>,
  React.ComponentPropsWithoutRef<typeof CmdGroup>
>(({ className, ...props }, ref) => (
  <CmdGroup
    ref={ref}
    className={cn(
      'overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground',
      className,
    )}
    {...props}
  />
))
CommandGroup.displayName = 'CommandGroup'

export const CommandItem = React.forwardRef<
  React.ElementRef<typeof CmdItem>,
  React.ComponentPropsWithoutRef<typeof CmdItem>
>(({ className, ...props }, ref) => (
  <CmdItem
    ref={ref}
    className={cn(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-accent aria-selected:text-accent-foreground data-[disabled='true']:pointer-events-none data-[disabled='true']:opacity-50",
      className,
    )}
    {...props}
  />
))
CommandItem.displayName = 'CommandItem'
